import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ShowForChannelDirective } from '@webapp/core/directives/showForChannel';
import { QUOTER_ROUTE_PATH } from '@webapp/core';
import { ButtonComponent, CardComponent, IconComponent } from '@webapp/ui';

@Component({
  selector: 'app-quoter-success',
  imports: [CardComponent, ButtonComponent, RouterLink, IconComponent, ShowForChannelDirective],
  templateUrl: './quoter-inspection-success.component.html',
  styleUrl: './quoter-inspection-success.component.scss',
})
export class QuoterInspectionSuccessComponent implements OnInit {
  quoterRoutePath = QUOTER_ROUTE_PATH;

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  loading = signal<boolean>(false);
  inspectionId = signal('');

  ngOnInit(): void {
    this.inspectionId = this.activatedRoute.snapshot.params['id'];
  }

  viewInspection() {
    this.router.navigate(['inspecciones', this.inspectionId]);
  }
}
